import { useEffect, useState } from "react";
import axios from "axios";
import { GET_BASE_URL } from "../utils/Constants";

// Safe default — keeps the current iframe flow if config.php is missing/unreachable.
const DEFAULT_CONFIG = { offer_mode: "iframe" };

// Module-level cache so config.php is fetched once per session, regardless of how
// many components call useConfig(). Concurrent callers share the same in-flight request.
let cachedConfig = null;
let inflight = null;

function loadConfig() {
  if (cachedConfig) return Promise.resolve(cachedConfig);
  if (inflight) return inflight;

  inflight = axios
    .get(GET_BASE_URL() + "config.php")
    .then((res) => {
      cachedConfig =
        res.data && typeof res.data === "object" ? res.data : DEFAULT_CONFIG;
      return cachedConfig;
    })
    .catch(() => {
      cachedConfig = DEFAULT_CONFIG;
      return cachedConfig;
    })
    .finally(() => {
      inflight = null;
    });

  return inflight;
}

export default function useConfig() {
  const [config, setConfig] = useState(cachedConfig);
  const [loading, setLoading] = useState(!cachedConfig);

  useEffect(() => {
    if (cachedConfig) {
      setConfig(cachedConfig);
      setLoading(false);
      return;
    }
    let active = true;
    loadConfig().then((c) => {
      if (!active) return;
      setConfig(c);
      setLoading(false);
    });
    return () => {
      active = false;
    };
  }, []);

  return { config: config || DEFAULT_CONFIG, loading };
}
